import { render, staticRenderFns } from "./MyStaffForm.vue?vue&type=template&id=aac97908"
import script from "./MyStaffForm.vue?vue&type=script&lang=js"
export * from "./MyStaffForm.vue?vue&type=script&lang=js"
import style0 from "./MyStaffForm.vue?vue&type=style&index=0&id=aac97908&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports